import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Button } from 'semantic-ui-react';

import { clearWeatherList } from '../actions/index';

class ClearButton extends Component {
	handleButtonClick = () => {
		this.props.clearWeatherList();
	};

	render() {
		return (
			<Container textAlign="center">
				<Button
					primary
					circular
					onClick={this.handleButtonClick}
					style={{ marginTop: '20px' }}
				>
					Clear all
				</Button>
			</Container>
		);
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ clearWeatherList }, dispatch);

export default connect(null, mapDispatchToProps)(ClearButton);



// WEBPACK FOOTER //
// ./src/containers/ClearButton.js